import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Wortmarke_Weiss.png'


const _withScopeId = n => (_pushScopeId("data-v-6f4bef24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "footer-links col-lg-4 text-lg-left text-center" }
const _hoisted_4 = {
  key: 0,
  class: "social-media-links my-2"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "col-lg-4 text-center mt-3 mt-lg-0" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://keravonos.de",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Logo",
    width: "120"
  })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4 text-lg-right text-center mt-3 mt-lg-0" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://keravonos.de/datenschutz",
    target: "_blank"
  }, "Datenschutzrichtlinien "),
  /*#__PURE__*/_createElementVNode("br", { class: "d-lg-none" }),
  /*#__PURE__*/_createElementVNode("p"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://keravonos.de/impressum",
    target: "_blank"
  }, " Impressum")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          ($data.socialMediaLinks)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.socialMediaLinks, (platform, name) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: name,
                    href: platform.link,
                    class: "mx-2"
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: platform.icon.split(' ')
                    }, null, 8, ["icon"]),
                    _createTextVNode(" " + _toDisplayString(name), 1)
                  ], 8, _hoisted_5))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode(" Made with "),
          _createVNode(_component_font_awesome_icon, { icon: ['fas', 'heart'] }),
          _createTextVNode(" by "),
          _hoisted_7
        ]),
        _hoisted_8
      ])
    ])
  ]))
}